import { useState } from 'react';
import { duckFinds } from '../../../mocks/whatTheDuck';

export default function DuckGallery() {
  const [selected, setSelected] = useState<typeof duckFinds[0] | null>(null);

  return (
    <section className="py-20 bg-gradient-to-b from-yellow-50 to-white" id="gallery">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block bg-yellow-100 text-yellow-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Community Gallery
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Ducks Found in the Wild 🦆
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Real finds from real moms across Gwinnett County and surrounding areas. Every duck has a story!
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-5">
          {duckFinds.map((duck) => (
            <div
              key={duck.id}
              onClick={() => setSelected(duck)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={duck.image}
                  alt={`Duck found at ${duck.location}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-white font-semibold text-sm">{duck.location}</p>
                <p className="text-white/75 text-xs mt-0.5">{duck.name} · {duck.date}</p>
              </div>
              <div className="absolute top-3 right-3 bg-yellow-400 text-gray-900 text-xs font-bold px-2.5 py-1 rounded-full">
                🦆 Found!
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm">
            Want your duck find featured here?{' '}
            <a href="#submit" className="text-pink-600 font-semibold hover:underline cursor-pointer">
              Submit your photo below ↓
            </a>
          </p>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selected && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setSelected(null)}
        >
          <div
            className="bg-white rounded-2xl overflow-hidden max-w-lg w-full shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-72 overflow-hidden">
              <img
                src={selected.image}
                alt={selected.location}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-2xl">🦆</span>
                <span className="bg-yellow-100 text-yellow-700 text-xs font-bold px-3 py-1 rounded-full">Duck Found!</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-1">{selected.location}</h3>
              <p className="text-gray-500 text-sm mb-3">{selected.name} · {selected.date}</p>
              <p className="text-gray-700 text-sm leading-relaxed italic">"{selected.caption}"</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-pink-600 text-sm font-semibold">#WhatTheDuck</span>
                <button
                  onClick={() => setSelected(null)}
                  className="text-sm text-gray-500 hover:text-gray-800 cursor-pointer transition-colors"
                >
                  Close ✕
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
